<template>
  <div class="recharge-agreement">
    <h1>《"搜机网"会员服务协议》</h1>
    <p>更新日期：2025年02月11日</p>
    <p>生效日期：2025年02月11日</p>
    <p>欢迎您使用"搜机网"付费会员服务！</p>
    <p>本"搜机网"会员服务（以下简称"本服务"）由北京泽雨昌盛科技有限公司和/或其关联方（以下统称"公司""我们"）提供，属于付费企业服务产品。</p>
    <p>
      为使用本服务，您需完整阅读、理解并遵守本《"搜机网"会员服务协议》（以下简称"本协议"）、《"搜机网"用户协议》《"搜机网"隐私政策》《"搜机网"创作者协议》等平台公示的全部协议及规则（以下统称"服务协议及规则"）。
    </p>
    <p>您在申请开通、支付购买本服务前，务必审慎研读全部条款，重点关注责任免除、权利限制、法律适用、争议解决等核心约束条款，以及对应单项服务的专属规则。请您确认完全理解并认可所有约定后，再进行后续操作。</p>
    <p>若您为无民事行为能力人或限制民事行为能力人，需在法定监护人全程陪同、指导并同意的前提下阅读本协议、使用本服务，严格遵守未成年人专属使用规则。</p>
    <p>若您为中国大陆地区以外用户，订立、履行本协议除遵守本协议约定外，还需严格遵守您所属、所处国家/地区的法律法规，因跨境使用产生的合规风险由您自行承担。</p>
    <p>若您不认可本协议任意条款，请立即终止会员开通、购买流程。您通过页面点击同意、确认支付、完成开通流程，或实际使用本服务等明示、默示方式使用本服务的，即表示您已完整阅读、充分理解、自愿接受本协议全部条款，与公司达成合法有效的服务约定，正式成为搜机网创作者会员，本协议即刻对双方产生法律约束力。</p>
    <p>一、定义及适用范围</p>
    <p>1.1 协议效力：本协议为您与公司之间，针对您注册、登录或游客模式下使用本付费会员服务所订立的专属法律协议。您任何确认操作或实际使用行为，均视为自愿签署本协议，本协议对双方均具有合法、有效、排他的法律约束力。</p>
    <p>1.2 搜机网创作者会员：指已完成搜机网平台注册登录、签署本协议，并按平台公示收费标准足额支付费用后，获取平台专属服务资格的用户。公司可根据业务发展合理调整会员名称，页面展示名称以当期公示为准，名称调整不影响用户已享有的合法会员权益。本协议中简称"商户会员"、"会员"或"您"。</p>
    <p>1.3 商户会员权益：指会员基于有效会员资格，可享受的平台专属服务、功能、权限等权益，具体内容以用户购买服务当期平台开通页面公示内容为准。公司有权根据业务迭代、服务优化需求不定期更新权益内容，更新后将通过平台公示、系统通知等方式告知，更新内容自公示之日起生效。</p>
    <p>1.4 会员有效期：会员服务页面公示的时长标准统一为：月度会员自开通之日起享有30天权益，年度会员自开通之日起享有365天权益，两年期会员自开通之日起享有730天权益，三年期会员自开通之日起享有1095天权益。会员服务有效期与搜机网平台合法存续期绑定，若平台终止运营，会员服务同步终止，公司将按法律法规及本协议约定处理后续事宜。</p>
    <p>1.5 协议组成：本协议内容包含平台已发布、后续合法发布的本服务相关补充协议、使用规则、公告说明等全部文件。前述文件经平台正式公示并通过页面展示、系统通知、公告推送等方式送达用户后，即为本协议不可分割的组成部分，与本协议正文具有同等法律效力，用户需一体遵守。</p>
    <p>二、服务开通、权益内容、服务期限及收费标准</p>
    <p>2.1 开通主体要求：本服务仅对搜机网完成注册、实名认证、正常登录的合规用户开放。您承诺在开通、使用本服务全过程中，具备完全民事权利能力与民事行为能力，拥有签署、履行本协议的合法资质与实际能力；若为企业用户，承诺具备合法经营资质，开通及使用行为均代表企业真实意愿。</p>
    <p>2.2 开通流程：您可通过平台官方公示的支付渠道、指定方式完成费用支付，提交会员开通申请。经公司审核通过、开通流程全部完成后，您方可正式享有对应会员权益、使用本服务。任何非官方渠道的开通、交易行为均无效，公司不承担任何责任。</p>
    <p>2.3 权益调整规则：本服务核心权益为平台商户使用搜机网平台上相关服务之权限。为优化用户体验、完善服务体系、适配业务发展，公司有权对会员权益、服务功能、页面展示、服务内容进行优化、更新、调整，包括新增、优化、删减部分功能及权益。调整后的服务内容以平台当期公示为准，用户继续使用服务即视为认可调整后的全部内容。</p>
    <p>2.4 服务期限规则：会员服务期限以用户自主选择、付费购买的对应时长为准。服务有效期届满后，平台自动终止对应会员权益，用户需重新付费开通方可继续使用。本服务存续依赖搜机网平台正常运营，若平台因合规调整、业务升级等合理原因暂停/终止运营，会员服务同步暂停/终止。</p>
    <p>2.5 费用调整规则：用户开通本服务需按页面公示标准支付对应服务费。公司可根据市场行情、业务迭代、服务升级等合理因素调整服务收费标准，费用调整后将通过平台公示，自公示之日起生效。调整前已开通的会员服务不受影响，服务到期后续费的，需按调整后的最新标准付费。</p>
    <p>2.6 价格说明</p>
    <p>（1）划线价格：页面展示的划线价格为市场参考价、行业指导价或历史销售价，仅作展示参考。因地区、时间、市场波动等因素，参考价与实时售价可能存在差异，不具备交易约束力；</p>
    <p>（2）未划线价格：页面实时展示的未划线价格为当期标准销售价，不因文字表述差异改变定价性质。最终成交价格受支付方式、平台优惠券、积分抵扣、汇率波动等影响，实际成交价以订单结算页公示金额为准；</p>
    <p>（3）活动促销价/折扣价：无特殊专项说明的，所有促销、折扣价格均为参考价基础上的平台优惠定价，仅限活动有效期内使用，优惠规则以当期活动公示为准；</p>
    <p>（4）价格异常处理：因系统缓存、页面延迟、数据异常等技术问题导致价格展示错误的，全部以订单结算页价格为唯一有效价格。用户发现价格异常的，需立即通过平台客服、意见反馈渠道告知公司，暂停交易，配合完成数据修正，公司对异常价格无履约义务。</p>
    <p>2.7 设备及费用承担：公司仅提供本协议约定的线上云服务、会员权益及平台功能支持。用户使用服务所需的硬件设备（电脑、手机、网络设备等）、网络资费、通讯费用等全部配套成本，均由用户自行承担。</p>
    <p>2.8 会员信息查询：用户成功开通会员后，可登录搜机网账号，在「我的-会员权益」页面查询会员类型、开通时长、有效期限、已解锁权益等全部会员信息，用户需定期自查，逾期未核查产生的权益损耗由用户自行承担。</p>
    <p>2.9 退款与转让规则：本服务会员权益属于虚拟数字服务产品，具有即时性、特殊性。除国家法律法规明确规定的退款情形外，用户付费开通后，权益不支持转让、赠与、售卖、退款、折现、提现。用户自愿开通、中途放弃使用、违规被终止服务、自身未使用权益等情形，均不予退款。</p>
    <p>三、服务使用规范</p>
    <p>3.1 账号专属使用规则：本会员服务及全部权益仅限账号初始注册人本人/本企业专属使用。未经公司书面盖章授权，用户不得以出租、出借、转让、售卖、共享、赠与等任何形式，允许第三方使用账号及项下会员权益、服务功能。</p>
    <p>公司有权对账号使用主体、使用行为进行核查，若发现实际使用人与注册人不一致、多人共享、转借账号等违规情形，为保障账号及平台安全，公司有权立即暂停、终止会员服务，且不予退款。用户需妥善保管账号、密码及登录信息，因自身保管不当、主动泄露、设备被盗等非公司原因导致的账号异常、权益损失、财产损失，均由用户自行承担。</p>
    <p>3.2 违规使用处罚规则：用户存在下列违法、违规、不当使用行为的，公司有权直接取消全部会员资格、作废所有未使用权益、终止全部服务，已支付的服务费不予退还；若给公司造成经济损失、品牌损失、合规风险、第三方索赔的，公司有权向用户全额追偿（包括直接损失、间接损失、维权律师费、诉讼费、赔偿金等）：</p>
    <p>（1）利用系统漏洞、外挂软件、爬虫、脚本、刷屏工具等非法技术手段，或通过非官方授权渠道获取、租用、借用会员服务的；</p>
    <p>（2）将会员权益、平台服务用于商业盈利、非法获利，或私自转让、共享、出租会员资格及权益的；</p>
    <p>（3）通过非法技术手段篡改会员有效期、消费记录、交易状态、权益权限，或违规使用会员服务的；</p>
    <p>（4）破解、绕过、篡改平台安全防护、权益验证技术措施，或协助第三方实施破解、篡改、破坏行为的；</p>
    <p>（5）利用平台活动漏洞、规则缺陷、系统错误，或滥用会员身份恶意套取平台福利、权益的；</p>
    <p>（6）将会员专属权益、素材、功能用于非个人合规使用、违规商业使用的；</p>
    <p>（7）违反法律法规、公序良俗、诚实信用原则及平台全部服务规则的其他行为。</p>
    <p>3.3 违规开通处置：用户通过恶意绕过官方开通流程、虚假信息、作弊手段、不正当方式开通会员服务的，公司有权直接驳回开通申请、终止已开通服务、取消或冻结全部/部分会员权益，且无需退还任何费用。</p>
    <p>3.4 服务通知推送：用户同意，公司可通过平台消息、系统通知、短信、站内信等方式，向用户推送会员权益更新、活动福利、服务升级、合规提醒等相关信息，用于保障用户正常使用服务，用户不得单方拒绝该合理服务通知。</p>
    <p>四、知识产权保护</p>
    <p>4.1 素材使用限制：用户使用平台功能进行商品报价和发布信息时，不得将平台提供的素材、模板、元素用于注册商标、品牌标识、企业徽标等商业标识体系中；不得将平台素材与第三方商标、图形、品牌标识绑定使用，用户自有独立版权的定制内容除外。</p>
    <p>4.2 平台知识产权保护：搜机网平台全部服务、素材、代码、功能、图文资料、技术体系均受知识产权法律法规保护。未经公司及相关权利人书面授权，任何用户、第三方不得实施反向工程、反编译、反汇编、破解、篡改、扒取、缓存、镜像、下载、复制等行为；不得利用平台资源开发同类、竞品产品及服务；不得协助第三方实施上述侵权行为。所有违规侵权行为造成的全部损失，由用户全额承担。</p>
    <p>4.3 内容传播限制：平台上相关使用教程和视频、图文教程、大盘行情、验机结果等全部会员专属内容，未经公司书面授权，用户不得以盈利或非盈利为目的，进行复制、编辑、翻拍、转载、出版、汇编、公开传播、商用引流等任何形式的对外传播使用。</p>
    <p>4.4 侵权处置机制：用户违规传播、商用、搬运平台专属内容，侵害公司及第三方知识产权、合法权益的，公司有权立即暂停、终止用户会员服务及账号使用权限，同时有权要求用户承担全部赔偿责任，并保留依法追究其民事、行政、刑事责任的全部权利。</p>
    <p>五、服务中止、终止及协议变更</p>
    <p>5.1 服务中止/终止情形：本服务可因下列情形中止或终止：</p>
    <p>（1）用户主动终止：包括会员到期未续费、用户主动申请注销账号、主动放弃会员权益等；</p>
    <p>（2）公司单方终止：用户存在违规、违约、侵权、违法使用等行为，公司依约中止或终止服务；</p>
    <p>（3）被动终止：因国家监管政策调整、政府部门责令整改、不可抗力等客观因素，公司中止或终止服务；</p>
    <p>（4）其他法定、约定的应当中止或终止服务的情形。</p>
    <p>5.2 主动终止不退费规则：服务有效期内，用户主动放弃权益、终止服务、注销账号，或因用户违约、违规被公司终止服务的，用户无权要求公司退还任何服务费。</p>
    <p>5.3 协议终止后续效力：本协议终止后，公司不再承担任何会员服务义务。协议终止不影响双方在协议存续期间已产生的权利义务，用户因自身过错导致公司遭受第三方索赔、行政处罚、经济损失的，需全额赔偿公司的全部损失及维权费用。</p>
    <p>5.4 协议变更规则：因互联网行业发展、法律法规更新、业务迭代、合规整改、用户权益保护等合理需求，公司有权不定期修订本协议条款。协议修订后将通过平台公示、系统通知等方式告知用户，修订内容自公示生效之日起执行。用户不同意修订内容的，可主动停止使用本服务；用户继续使用服务的，视为自愿认可并接受修订后的全部条款。</p>
    <p>六、责任限制</p>
    <p>6.1 服务风险告知：用户明确知晓并同意，本服务基于当前互联网技术条件、行业现状提供，公司将尽合理努力保障服务稳定、安全、连续运行。但互联网行业存在固有技术风险，不可抗力、网络故障、第三方服务异常、系统延迟、黑客攻击、设备故障等不可预见、不可避免的因素，可能导致服务临时中断、功能异常、无法正常使用，公司对此不承担违约及赔偿责任。</p>
    <p>6.2 赔偿上限约定：基于公平原则、权利义务对等原则，因公司单方过错导致服务异常、中断、无法使用，给用户造成损失的，公司的全部赔偿责任上限不超过用户当期已支付的对应会员服务费用总额，不承担间接损失、预期收益损失、商誉损失等额外赔偿。</p>
    <p>七、未成年人使用特别约定</p>
    <p>7.1 监护使用要求：未满18周岁的未成年用户，必须在法定监护人全程监督、指导、同意的前提下，阅读本协议、开通并使用本服务。未成年人自行开通、使用服务产生的一切后果，由监护人承担全部责任。</p>
    <p>7.2 未成年人责任承担：未成年用户违反法律法规、本协议约定使用服务的，由未成年人及其法定监护人共同承担全部法律责任、违约赔偿责任。</p>
    <p>7.3 未成年人使用规范：青少年用户需自觉遵守《全国青少年网络文明公约》，理性、合规、适度使用网络服务，杜绝沉迷网络，不利用本服务实施违规、违法行为。</p>
    <p>7.4 监护人责任提示</p>
    <p>（1）监护人确认，被监护人注册、使用平台服务、开通付费会员的，公司有权视为已获得监护人完全同意；</p>
    <p>（2）监护人需妥善保管自身支付账户、密码、设备，对被监护人的付费操作、账号使用行为承担全部监管责任，因监管疏漏导致的未成年人违规付费、不当使用，公司不承担任何退款及赔偿责任。</p>
    <p>八、其他约定</p>
    <p>8.1 条款独立性：本协议任意条款被有权机关认定为无效、不可执行、废止的，不影响协议其他全部条款的法律效力，剩余条款继续完整有效、对双方具有约束力。</p>
    <p>8.2 法律适用：本协议的订立、生效、履行、解释、争议解决，均适用中华人民共和国大陆地区法律。协议条款与现行法律冲突无效的，按最接近原条款本意的法律规则执行，其余条款继续有效。</p>
    <p>8.3 争议解决：本协议签订地为中华人民共和国天津市南开区。双方因本协议产生的任何争议、纠纷，应优先友好协商解决；协商不成的，任何一方均需向本协议签订地人民法院提起诉讼解决。</p>
    <p>8.4 协议优先级：本协议与平台其他服务规则、协议对同一事项约定冲突的，以本协议约定为准；本协议未约定的，适用平台其他公示规则；无相关规则的，由双方另行协商约定。</p>
    <p>8.5 咨询与反馈渠道：用户对本服务、本协议有疑问、建议、投诉的，可通过搜机网平台「我的-客服/意见反馈」通道，或发送邮件至官方客服邮箱：souji168@souji168.cn 进行反馈。</p>
    <p>8.6 版权与解释权：本协议全部内容版权归北京泽雨昌盛科技有限公司所有，公司依法享有独家修改、更新、最终解释的权利。</p>
  </div>
</template>

<script>
export default {
  name: 'RechargeAgreement'
}
</script>

<style scoped lang="scss">
.recharge-agreement {
  width: 98%;
  margin: 0 auto;
  padding: 1%;
  font-size: 14px;
  line-height: 1.6;
  text-indent: 32px;

  h1 {
    text-align: center;
    margin-bottom: 20px;
    text-indent: 0;
    margin-top: 10px;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 10px;
  }
}
</style>
